let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("c6aDa")).then(() => parcelRequire('4n6tJ'));